// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"d04d23d9","453":"1ce678f8","462":"1003f4e3","498":"fefee5f2","551":"9d7310f3","616":"b0e1fdb5","629":"d72465bf"}[chunkId] + ".chunk.js";
};